'use strict';

var _setup = require('./setup.js');

var _productSingle = require('./product-single.js');

//story product fw image
var stickyNavSubscribe = function stickyNavSubscribe() {
  $('.nx-subnav--subscribe').on('click', function (e) {
    e.preventDefault();

    var distance = _setup.s.$footer.offset().top - _setup._s.scrollCurrent;
    var duration = distance / 1000 * 0.38;

    TweenMax.to(window, duration, { scrollTo: _setup.s.$footer[0], ease: Expo.easeOut, onComplete: function onComplete() {
        $('#newsletter-email-input').focus();
      } });
  });
};

if (_setup.s.isArticle && _productSingle.hasSubnav) {
  requestAnimationFrame(stickyNavSubscribe);
}

//anything specific to recipes / single recipes
//add grilltips to recipe grids
var insertGrillTips = function insertGrillTips() {
  var $recipeGrids = $('.nx-collectionlist--items .nx-bloglist--ul');
  var $grilltips = _setup.s.$recipeGrilltips.find('li');

  //console.log($grilltips);

  $grilltips.detach();

  $recipeGrids.each(function (index) {
    var $tip = $grilltips.eq(index);

    if ($tip.length === 0) return;

    var $gridItems = $(this).find('li');
    var placementIndex = _setup.s.randomInt(2, 4);
    var gridHeight = $gridItems.first().css('height');

    $tip.css({ height: gridHeight }).insertAfter($gridItems.eq(placementIndex));
  });
};

if (_setup.s.$recipeGrilltips.length) {
  requestAnimationFrame(insertGrillTips);
}

// Dirty, dirty script to add extra padding-top to h2, h3, and h4 elements on grilling-tips page.
// Can't think of a better way to dynamically style varying content like that - Doug
// if (window.location.href.includes('grilling-tips')) {
//   const targets = [
//     $('.nx-blogbody h2'),
//     $('.nx-blogbody h3'),
//     $('.nx-blogbody h4'),
//   ];

//   $.each(targets, (index, target) => {
//     const $t = $(target);
//     $t.css({ 'padding-top': '1.875em' });
//   });
// }


//////////////////
// WEBPACK FOOTER
// ./_js/blogs.js
// module id = 15
// module chunks = 0